import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

export function initializeBardImageSlider() {
    new Swiper(".bardImageSlider", {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        navigation: {
            nextEl: ".thumbImageSlider__navigation-button-next",
            prevEl: ".thumbImageSlider__navigation-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        on: {
            init: (swiper) => {
                swiper.el.classList.add('swiper-initialized');
            },
        },
    });
}
